import { render, staticRenderFns } from "./Paginas.vue?vue&type=template&id=4717e3a9&"
import script from "./Paginas.vue?vue&type=script&lang=js&"
export * from "./Paginas.vue?vue&type=script&lang=js&"
import style0 from "./Paginas.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Paginas.vue"
export default component.exports